import React, { useState } from "react";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";
import "../ContactUs/Contact.css"
 
const EditAsra = () => {
    // const [links, setLinks] = useState([
    //     { id: 1, media: "Instagram", link: "https://www.instagram.com/asraimmigration", active: true },
    //     { id: 2, media: "Twitter", link: "https://twitter.com/asraimmigration", active: true },
    //     { id: 3, media: "Facebook", link: "https://www.facebook.com/asraimmigration", active: true },
    //     { id: 4, media: "LinkedIn", link: "https://www.linkedin.com/company/asraimmigration", active: false },
    //     { id: 5, media: "YouTube", link: "https://www.youtube.com/asraimmigration", active: false },
    // ]);
 
 
    return (
        <div className="edit-social">
            <div className="social-header-bar">
                <h2>Edit Asra Impact</h2>
                <button className="save-btn">Save</button>
            </div>
 
 
           <div className="edit-social-container2">
              <div className="col-lg-12">
                 
                 
                        <div className="form-group col-11">
                            <label>Heading <span className="required">*</span></label>
                            <input type="text" className="form-control" placeholder="Enter your text here..." />  
                   
                </div>
              </div>
 
            <div className="edit-social-container1">
                {/* Left Section */}
 
                <div className="left-form">
                    <div className="form-group ">
                        <label>
                            Title <span className="required">*</span>
                        </label>
                        <input type="text" placeholder="Enter your text here..." maxLength={150} />
                        <small>0/150</small>
                    </div>
                      <div className="form-group">
                                            <label>
                                                Description <span className="required">*</span>
                                            </label>
                                            
                                            <ReactQuill
                                              
                                                placeholder="Enter description"
                                                className="description-editor"
                                            />
                                        </div>
                </div>
 
                {/* Right Section */}
                <div className="right-section">
                    <div className="social-header">
                    </div>
 
                    <div className="social-list">
                            <div  className="social-item">
                                <label className="switch1">
                                    <input
                                        type="checkbox"
                                    />
                                    <span className="slider2 round"></span>
 
                                </label>
                                <div className="social-inputs">
                                    <div className="input-group1">
                                        <label>
                                            Count <span className="required">*</span>
                                        </label>
                                        <input type="text"  readOnly />
                                    </div>
 
                                    <div className="input-group1">
                                        <label>
                                            Title <span className="required">*</span>
                                        </label>
                                        <input type="text"  readOnly />
                                    </div>
                                </div>
 
 
                            </div>
                    </div>

                     <div className="social-list">
                            <div  className="social-item">
                                <label className="switch1">
                                    <input
                                        type="checkbox"
                                    />
                                    <span className="slider2 round"></span>
 
                                </label>
                                <div className="social-inputs">
                                    <div className="input-group1">
                                        <label>
                                            Count <span className="required">*</span>
                                        </label>
                                        <input type="text"  readOnly />
                                    </div>
 
                                    <div className="input-group1">
                                        <label>
                                            Title <span className="required">*</span>
                                        </label>
                                        <input type="text"  readOnly />
                                    </div>
                                </div>
                            </div>
                    </div>

                      <div className="social-list">
                            <div  className="social-item">
                                <label className="switch1">
                                    <input
                                        type="checkbox"
                                    />
                                    <span className="slider2 round"></span>
 
                                </label>
                                <div className="social-inputs">
                                    <div className="input-group1">
                                        <label>
                                            Count <span className="required">*</span>
                                        </label>
                                        <input type="text"  readOnly />
                                    </div>
 
                                    <div className="input-group1">
                                        <label>
                                            Title <span className="required">*</span>
                                        </label>
                                        <input type="text"  readOnly />
                                    </div>
                                </div>
                            </div>
                    </div>

                      <div className="social-list">
                            <div  className="social-item">
                                <label className="switch1">
                                    <input
                                        type="checkbox"
                                    />
                                    <span className="slider2 round"></span>
 
                                </label>
                                <div className="social-inputs">
                                    <div className="input-group1">
                                        <label>
                                            Count <span className="required">*</span>
                                        </label>
                                        <input type="text"  readOnly />
                                    </div>
 
                                    <div className="input-group1">
                                        <label>
                                            Title <span className="required">*</span>
                                        </label>
                                        <input type="text"  readOnly />
                                    </div>
                                </div>
                            </div>
                    </div>
                    
                </div>
            </div>
             </div>
             </div>
    );
};
 
export default EditAsra;